import { shallowEqual, useSelector } from "react-redux";

import Column from "theme/layouts/Column";
import React from "react";
import TextLink from "theme/components/text/TextLink";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";

const Wrapper = styled("div")`
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    border-top: 1px solid ${({ theme }) => theme.colors.black_10};

    ${({ theme }) => theme.above.tabletLg} {
        grid-template-columns: 340px 1fr 1fr;
    }
`;

const NoResultsWrapper = styled(Column)`
    padding-right: 24px;

    ${({ theme }) => theme.above.tabletLg} {
        border-right: 1px solid ${({ theme }) => theme.colors.black_10};
    }
`;

const SuggestionsWrapper = styled("div")`
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: 100%;

    ${({ theme }) => theme.above.tabletLg} {
        flex-direction: row;
        gap: 24px;
    }
`;

const SearchSuggestions = ({ query }) => {
    const { t } = useTranslation();

    const noResultsText = useSelector(({ page }) => page.data.no_search_results?.text) || [];
    const suggestionSections = useSelector(({ header }) => header?.data?.search?.suggestions, shallowEqual) || [];

    return (
        <Wrapper py="24px">
            <NoResultsWrapper gap="16px">
                <TextStyles textStyles="Myriad Pro/16-100-semibold-semiextended">
                    {t("search.search_query_not_found", { query })}
                </TextStyles>
                <Wysiwyg
                    data={noResultsText}
                    textComponent={(props) => <TextStyles textStyles="Myriad Pro/14-140" {...props} />}
                />
            </NoResultsWrapper>
            <SuggestionsWrapper>
                {suggestionSections?.map(({ heading, links }) => (
                    <Column gap="24px" key={heading}>
                        <TextStyles textStyles="Myriad Pro/14-100-semibold">{heading}</TextStyles>

                        <Column gap="10px" key={heading}>
                            {links?.map(({ link }) => (
                                <TextLink
                                    key={`${link?.url}-${link.text}`}
                                    to={link?.url}
                                    textStyles="Myriad Pro/16-100"
                                >
                                    {link?.text}
                                </TextLink>
                            ))}
                        </Column>
                    </Column>
                ))}
            </SuggestionsWrapper>
        </Wrapper>
    );
};

export default SearchSuggestions;
